import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { WorkflowConditionOperatorEnum } from "schema"

export function useConditionOperatorMap() {
  const { t } = useTranslation()

  return useMemo(
    () =>
      ({
        [WorkflowConditionOperatorEnum.Equals]: "=",
        [WorkflowConditionOperatorEnum.NotEquals]: "≠",
        [WorkflowConditionOperatorEnum.GreaterThan]: ">",
        [WorkflowConditionOperatorEnum.GreaterThanOrEqual]: "≥",
        [WorkflowConditionOperatorEnum.LessThan]: "<",
        [WorkflowConditionOperatorEnum.LessThanOrEqual]: "≤",
        [WorkflowConditionOperatorEnum.IsNull]: t("campaigns.condition.operators.IsNull"),
        [WorkflowConditionOperatorEnum.IsNotNull]: t("campaigns.condition.operators.IsNotNull"),
        [WorkflowConditionOperatorEnum.ReturnsTrue]: t(
          "campaigns.condition.operatorsPreview.ReturnsTrue",
        ),
        [WorkflowConditionOperatorEnum.ReturnsFalse]: t(
          "campaigns.condition.operatorsPreview.ReturnsFalse",
        ),
      }) as Record<string, string>,
    [t],
  )
}
